/* global yaCounter51365074 */

import router from './router';
import scrollDepth from 'scroll-depth';
import helpers from './helpers';

let timerCounts = 0;

function start15SecTimeout() {
	if (timerCounts < 15) {
		clearTimeout($(window).data('timeout15Sec'));

		timerCounts++;

		$(window).data('timeout15Sec', setTimeout(() => {
			ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
			ga('send', 'event', 'page', 'spent_on_page_15_sec');

			start15SecTimeout();
		}, 15000));
	}
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter51365074) {
		yaCounter51365074.hit(path);
	}
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
	},
});

router.on('enter', (prevState, currentState) => {
	start15SecTimeout();

	if (!currentState.route) {
		return Promise.resolve();
	}

	if (prevState.route) {
		virtualHit(location.pathname);
		scrollDepth.reset();
	}

	return Promise.resolve();
});

$('.header__logo-porsche, .stub__logo-porsche').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.header__logo-rbc-style, .stub__logo-rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.home__info').on('mouseenter', () => {
	ga('send', 'event', 'nav', 'about project');
});

$('.timeline__navigation__link').on('click', (e) => {
	let name = helpers.clearText($(e.currentTarget).text());

	ga('send', 'event', 'nav', 'timeline', name);
});

$('.timeline__sound__toggle').on('click', () => {
	ga('send', 'event', 'nav', 'mute');
});

$('.home__start').on('click', () => {
	ga('send', 'event', 'main', 'start click');
});

$('.home__share__button').on('click', (e) => {
	let socialName = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'main share', socialName);
});

$('.timeline__start').on('click', (e) => {
	let $this = $(e.currentTarget);
	let name = $this.closest('.page').find('.timeline__navigation__link.is-active').text();

	ga('send', 'event', 'timeline page', 'start click main', name);
});

$('.timeline__play__button').on('click', (e) => {
	let $this = $(e.currentTarget);
	let name = $this.closest('.page').find('.timeline__navigation__link.is-active').text();
	let $page = $this.closest('.page');

	if ($page.hasClass('is-playing')) {
		ga('send', 'event', 'timeline page', 'pause click footer', name);
	} else if ($page.hasClass('is-complete')) {
		ga('send', 'event', 'timeline page', 'next click footer', name);
	} else if ($page.hasClass('is-last is-complete')) {
		ga('send', 'event', 'timeline page', 'to beginning click footer', name);
	} else {
		ga('send', 'event', 'timeline page', 'start click footer', name);
	}
});

$('.timeline__popup__close').on('click', (e) => {
	let $this = $(e.currentTarget);
	let timeline = $this.closest('.page').find('.timeline__navigation__link.is-active').text();
	let popupname = $this.closest('.timeline__popup').find('.timeline__popup__title').text();
	let name = `${timeline} || ${popupname}`;

	ga('send', 'event', 'timeline page', 'popup close', name);
});

$('.timeline__popup__button').on('click', (e) => {
	let $this = $(e.currentTarget);
	let timeline = $this.closest('.page').find('.timeline__navigation__link.is-active').text();
	let popupname = $this.closest('.timeline__popup').find('.timeline__popup__title').text();
	let name = `${timeline} || ${popupname}`;

	ga('send', 'event', 'client link', 'from popup', name);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.timeline__share__button').on('click', (e) => {
	let socialName = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'timeline share', socialName);
});

$('.timeline__client-link').on('click', () => {
	ga('send', 'event', 'client link', 'timeline block on last screen');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.timeline__popup__nav, .timeline__popup__dot__btn').on('click', (e) => {
	let $popup = $(e.currentTarget).closest('.page').find('.timeline__popup.is-open');
	let name = $popup.find('.timeline__popup__title').text();

	$(document).trigger('open-popup', [$popup]);

	ga('send', 'event', 'timeline page', 'slider change', name);
});

$(document).on('open-popup', (e, $popup) => {
	let timeline = $popup.closest('.page').find('.timeline__navigation__link.is-active').text();
	let popupname = $popup.find('.timeline__popup__title').text();
	let name = `${timeline} || ${popupname}`;

	ga('send', 'event', 'timeline page', 'popup open', name);
});
